import Favorite from '../favorite';

/**
 * Create the action
 */

const { thunk, request, success, error } = Favorite.index((fetch) => {
    return fetch.get('/favorites');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
